module.exports = __webpack_public_path__ + "img/42.ecbd46a5.png";